import React, {
    useState,
    useEffect,
} from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import {
    Button,
    Form,
    FormGroup,
    Input,
    Label,
} from 'reactstrap'
import { useAppSelector } from '../../hooks/redux'
import { login as loginFunc } from '../shared/auth'

interface LoginFormProps {
    hasLabel?: boolean
    layout?: string
}

/**
 * Login form with email/password fields and forgotten-password link.
 */
const LoginForm = ({
    hasLabel = false,
}: LoginFormProps) => {
    const [email, setEmail] = useState<string>('')
    const [password, setPassword] = useState<string>('')
    const [isDisabled, setIsDisabled] = useState<boolean>(true)

    const { t } = useTranslation()
    const navigate = useNavigate()
    const errorAuth = useAppSelector(state => state.auth.error)

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>): void => {
        e.preventDefault()
        toast.success(`Logged in as ${email}`)
        loginFunc(email, password).then(() => navigate('/'))
    }

    useEffect(() => {
        setIsDisabled(!email || !password)
    }, [email, password])

    if (errorAuth) {
        toast.error(`Error`)
    }

    return (
        <Form onSubmit={handleSubmit}>
            <FormGroup>
                {hasLabel &&
                    <Label>{t('auth.email')}</Label>
                }
                <Input
                    value={email}
                    onChange={({ target }) => setEmail(target.value)}
                    type='email'
                />
            </FormGroup>
            <FormGroup>
                {hasLabel &&
                    <Label>{t('auth.password')}</Label>}
                <Input
                    value={password}
                    onChange={({ target }) => setPassword(target.value)}
                    type='password'
                />
            </FormGroup>
            <Link
                to="/forgotten-password"
                className="text-dark"
            >
                {t('auth.forgottenPassword')}
            </Link>
            <FormGroup>
                <Button
                    color='primary'
                    block
                    className='mt-3'
                    disabled={isDisabled}
                >
                    {t('auth.login')}
                </Button>
            </FormGroup>
        </Form>
    )
}

export default LoginForm
